import React from 'react';
import classNames from 'classnames';
import {} from 'antd';
import { useTranslation } from 'react-i18next';
import { makePrioStyles } from '../../../../theme/utils';
import { EmployeeOverviewCalculatedData } from '../../../../models/TimeKeeping';
import { DefaultSearchParameterItem } from '../../../../components/Filter/types';
import { EmployeeContact } from '../../../../models/Employee';
import FilterContextProvider from '../../../../components/Filter/FilterContextProvider';
import { FilterBar } from '../../../../components/Filter/FilterBar';
import HRTimeKeepingOverviewPageTable from './HRTimeKeepingOverviewPageTable';
import Flex from '../../../../components/Flex';

const useStyles = makePrioStyles((theme) => ({
  root: {
    margin: theme.spacing.regular,
    '&.prio-virtual-table': {
      height: 'unset',
    },
  },
  container: {
    padding: theme.spacing.large,
  },
  header: {
    paddingBottom: theme.spacing.large,
  },
}));

interface HRTimeKeepingOverviewPageProps {
  className?: string;
  officeId: string;
}

export const HRTimeKeepingOverviewPage: React.FC<
  HRTimeKeepingOverviewPageProps
> = (props) => {
  //#region ------------------------------ Defaults
  const { className, officeId } = props;
  const classes = useStyles();
  const { t } = useTranslation();
  //#endregion

  //#region ------------------------------ States / Attributes / Selectors
  const customDefaultSearchParameters: DefaultSearchParameterItem[] = [
    {
      parameterName: 'OfficeId',
      defaultValue: officeId,
      defaultMethod: 'eq',
    },
  ];
  //#endregion

  //#region ------------------------------ Methods / Handlers

  //#endregion

  //#region ------------------------------ Effects
  //#endregion

  return (
    <Flex.Column className={classNames(className, classes.container)}>
      <FilterContextProvider<EmployeeContact, EmployeeOverviewCalculatedData>
        searchType="employeeOverview"
        equalityFunction={({ data: a }, { data: b }) =>
          a.employeeContactId === b.employeeContactId
        }
        customDefaultSearchParameters={customDefaultSearchParameters}
      >
        <h2 className={classes.header}>
          {t('hr:timeAndLeaveManagement.overview.yearSummary', {
            year: new Date().getFullYear(),
            defaultValue:
              'Übersicht über das Jahr {{year}} - Zusammenfassung von Arbeitszeiten und Abwesenheiten',
          })}
        </h2>
        <FilterBar />
        <HRTimeKeepingOverviewPageTable />
      </FilterContextProvider>
    </Flex.Column>
  );
};

export default HRTimeKeepingOverviewPage;
